export const INTERVIEW_END_NOTIFICATION =
  " ended the interview for\nall. Moving you to the feedback page";
export const INTERVIEW_TIME_END_NOTIFICATION =
  "Maximum interview duration is 3hrs.\nTime left in this interview is";
export const NO_INTERVIEWER_NOTIFICATION =
  "There are no interviewers present.\nMoving you out of this window.";
export const ASK_JOIN_INTERVIEW_NOTIFICATION = " wants to join this interview";
export const USER_LEFT_NOTIFICATION = " has left the interview";
export const USER_JOIN_NOTIFICATION = " has joined the interview";
